'use client';
// see: https://stackoverflow.com/questions/75692116/next-js-13-window-is-not-defined
import { createContext, FC, ReactNode,useContext, useEffect, useState } from 'react';

const IsClientCtx = createContext(false);

export const IsClientCtxProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => setIsClient(true), []);
  return <IsClientCtx.Provider value={isClient}>{children}</IsClientCtx.Provider>;
};

export function useIsClient() {
  return useContext(IsClientCtx);
}
